import React from "react";
import { useTheme } from "@mui/material/styles";
import { getDotColor, getLabelClassName } from "@components/Badge/Badge.styles";
import type { BadgeProps } from "@components/Badge/Badge.types.ts";

const Badge: React.FC<BadgeProps> = ({ testId, labelTestId, type, bold = false, label }) => {
  const theme = useTheme();
  const dotColor = getDotColor(type, theme);

  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {/* Dot */}
      <div className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: dotColor }} />

      {/* Label */}
      <div className={getLabelClassName(bold)} data-testid={labelTestId}>
        {label}
      </div>
    </div>
  );
};

export default Badge;
